import _ from 'lodash';
import { USER_ADMIN } from './main';

export const NEW_POSTS = 'new_posts';
export const NEW_LOGIN = 'new_login';
export const NEW_OFFERS = 'new_offers';
export const NEW_COMMENTS = 'new_comments';
export const NEW_MESSAGES = 'new_messages';
export const NEW_NEWS = 'new_news';
export const NEW_FRIENDSHIPS = 'new_friendships';
export const NOTIFICATION_EMAIL = 'notification_email';

export const AS_GUEST = 'guest';
export const AS_OWNER = 'owner';
export const AS_USER = 'user';

export const EVENT_TAB = 'events';
export const POSTS_TAB = 'posts';
export const ABOUT_TAB = 'about';
export const ALBUM_TAB = 'albums';
export const COLLECTION_TAB = 'collection';
export const MARKET_TAB = 'market';

export const tabs = [EVENT_TAB, POSTS_TAB, ABOUT_TAB, COLLECTION_TAB, MARKET_TAB, ALBUM_TAB];

export const isAdmin = (user) => {
  if (_.get(user, '_id')) {
    return _.get(user, 'role') === USER_ADMIN;
  }
  return false;
};

export const SIGN_IN_INFO = {
  collector: {
    text: 'У меня есть коллекция и я хочу показывать ее, участвовать в выставках и общаться с коллегами',
    image: '/images/collector.svg',
  },
  artist: {
    text: 'Публикую свои работы для любителей, коллекционеров, специалистов и кураторов',
    image: '/images/artist.svg',
  },
  amateur: {
    text: 'Я - наблюдатель, мне интересна сфера искусства',
    image: '/images/amateur.svg',
  },
  curator: {
    text: 'Организовываю выставки, хочу общаться с коллекционерами и договариваться о передаче экспонатов для своих проектов',
    image: '/images/curator.svg',
  },
  dealer: {
    text: 'Хочу покупать и продавать работы других художников',
    image: '/images/specialist.svg',
  },
  gallery: {
    text: 'Хочу продавать и показывать работы других художников',
    image: '/images/spotter.svg',
  },
};
